var cr = require( 'webcrypto' );

import blSession 	from './_session.jsx';
import blUtil 		from './_utils.jsx';

var blSecurity = 
{
	encrypt:
	function(data){
		var	bls			= blSession;
		var blu			= blUtil;
		var	_s			= 'YWVzLTEyOC1lY2I=';
		var	_i			= bls._s;
		var	_c			= cr.createCipher( blu.__d1( _s ), blu.__d1( _i ) );
		var	dataText 	= JSON.stringify( data );

		var _cc 	= _c.update( dataText, 'utf-8', 'hex' ); _cc += _c.final( 'hex' );
		return _cc;
	}
}

export default blSecurity;